export default __webpack_public_path__ + "static/media/chart-net-energy.d243a886.png";